module.exports = __webpack_public_path__ + "img/pic3.22bc3a28.png";